import { localStorage, sessionStorage } from 'dibs-browser-storage';
const IMPRESSION_COUNT = 5;

const DEFAULT_DATA = {
    impressionCount: 0,
    isForceClosed: false,
};

const STORAGE_NAMESPACE = 'promotionBanner';

function wasShownThisSession(namespace) {
    const storageData = sessionStorage.getItem(STORAGE_NAMESPACE) || {};
    return storageData[namespace] || false;
}

function setShownThisSession(namespace) {
    const storageData = sessionStorage.getItem(STORAGE_NAMESPACE) || {};
    sessionStorage.setItem(STORAGE_NAMESPACE, { ...storageData, [namespace]: true });
}

function getLocalStorageData(namespace) {
    const storageData = localStorage.getItem(STORAGE_NAMESPACE) || {};
    if (storageData[namespace]) {
        return storageData[namespace];
    }

    localStorage.setItem(STORAGE_NAMESPACE, { ...storageData, [namespace]: DEFAULT_DATA });
    return DEFAULT_DATA;
}

function setLocalStorageData(namespace, payload) {
    const data = localStorage.getItem(STORAGE_NAMESPACE) || {};
    const newData = {
        ...data,
        [namespace]: { ...DEFAULT_DATA, ...(data[namespace] || {}), ...payload },
    };
    localStorage.setItem(STORAGE_NAMESPACE, newData);
    return newData;
}

function canShowBanner(namespace) {
    const { impressionCount, isForceClosed } = getLocalStorageData(namespace);
    return !isForceClosed && impressionCount < IMPRESSION_COUNT;
}

export const DESIGN_SERVICE_BANNER = 'designServiceBanner';

export const canShowDesignServiceBanner = ({ isVerifiedTrade, isVip } = {}) => {
    return !isVerifiedTrade && !isVip && canShowBanner(DESIGN_SERVICE_BANNER);
};

export const increaseShowCount = namespace => {
    if (!wasShownThisSession(namespace)) {
        setShownThisSession(namespace);
        let { impressionCount } = getLocalStorageData(namespace);
        impressionCount += 1;
        setLocalStorageData(namespace, { impressionCount });
    }
};

export const forceCloseBanner = namespace => {
    setLocalStorageData(namespace, { isForceClosed: true });
};
